import React, { Suspense, lazy } from "react";
import {HashRouter as Router, Route, Switch} from "react-router-dom";
import Layout from "./layout";
import Loading from "Components/Loading";
import Home from "./pages/NewHome";
import Ifr from "./pages/ifr";
import NotFound from "./pages/404";
import Ui from "./pages/UserInfo";
import Log from "./pages/OwnLog";
import ZoneSetting from "./pages/ZoneSetting";
import C from "./pages/Customize";
import ErrorCenter from "./pages/ErrorCenter";
import SubjectSetting from "./pages/Customize/SubjectSetting";
import GlobalStyleSetting from "./pages/CompanyStyleSetting/GlobalStyleSetting";
import GroupStyleSetting from "./pages/CompanyStyleSetting/GroupStyleSetting";
import OpenApp from "./pages/OpenApp";

export const routes = [
    {
        path: "/",
        exact: true,
        component: lazy(() => import(/* webpackChunkName: "static/pages/NewHome" */ "Pages/NewHome")),
        syncComponent: Home
    },
    {
        path: "/ifr",
        component: lazy(() => import(/* webpackChunkName: "static/pages/ifr" */ "Pages/ifr")),
        syncComponent: Ifr
    },
    {
        path: "/404",
        component: lazy(() => import(/* webpackChunkName: "static/pages/404" */ "Pages/404")),
        syncComponent: NotFound
    },
    {
        path: "/ui",
        exact: true,
        component: lazy(() => import(/* webpackChunkName: "static/pages/UserInfo" */ "Pages/UserInfo")),
        syncComponent: Ui
    },
    {
        path: "/log",
        component: lazy(() => import(/* webpackChunkName: "static/pages/OwnLog" */ "Pages/OwnLog")),
        syncComponent: Log
    },
    {
        path: "/ZoneSetting",
        component: lazy(() => import(/* webpackChunkName: "static/pages/ZoneSetting" */ "Pages/ZoneSetting")),
        syncComponent: ZoneSetting
    },
    {
        path: "/c",
        component: lazy(() => import(/* webpackChunkName: "static/pages/Customize" */ "Pages/Customize")),
        syncComponent: C
    },
    {
        path: "/errorCenter",
        component: lazy(() => import(/* webpackChunkName: "static/pages/ErrorCenter" */ "Pages/ErrorCenter")),
        syncComponent: ErrorCenter
    },
    {
        path: "/subjectSetting",
        component: lazy(() => import(/* webpackChunkName: "static/pages/Customize/SubjectSetting" */"Pages/Customize/SubjectSetting")),
        syncComponent: SubjectSetting
    },
    {
        path: "/GlobalStyleSetting",
        component: lazy(() => import(/* webpackChunkName: "static/pages/CompanyStyleSetting/GlobalStyleSetting" */"Pages/CompanyStyleSetting/GlobalStyleSetting")),
        syncComponent: GlobalStyleSetting
    },
    {
        path: "/GroupStyleSetting",
        component: lazy(() => import(/* webpackChunkName: "static/pages/CompanyStyleSetting/GroupStyleSetting" */"Pages/CompanyStyleSetting/GroupStyleSetting")),
        syncComponent: GroupStyleSetting
    },
    {
        path: "/openApp",
        component: lazy(() => import(/* webpackChunkName: "static/pages/OpenApp" */"Pages/OpenApp")),
        syncComponent: OpenApp
    },
];

// 不需要水印的路由页面
// 企业风格设置（全局、集团）
export const NoNeedWatermarkRoutes = ['/GlobalStyleSetting', '/GroupStyleSetting'];

const RouteWithSubRoutes = route => (
    <Route
        path={route.path}
        render={props => (
            // pass the sub-routes down to keep nesting
            <route.component {...props} {...route.rootProps} />
        )}
    />
);

const RouteConfig = (rootProps) => (
    <Router>
        <Suspense fallback={<Loading/>}>
            <Layout {...rootProps}>
                <Switch>
                    {routes.map((route, i) => (
                        <RouteWithSubRoutes key={i} {...route} rootProps={rootProps} />
                    ))}
                    <Route
                        component={infor => <NotFound location={infor.location} />}
                    />
                </Switch>
            </Layout>
        </Suspense>
    </Router>
);
export default RouteConfig;
